var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConvertibleDefault = function SvgConvertibleDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M13.405 13.969a.885.885 0 1 1-1.77 0 .885.885 0 0 1 1.77 0ZM37.346 13.969a.885.885 0 1 1-1.77 0 .885.885 0 0 1 1.77 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m10.228 14.771-4.214-1.54a.3.3 0 0 1-.079-.046v0a2.465 2.465 0 0 1-.446-3.171l.087-.138a.3.3 0 0 0 .04-.122l.131-1.712a.79.79 0 0 1 .618-.709 66 66 0 0 0 4.428-1.208.78.78 0 0 1 .538.03l.615.266q.072.03.15.047l2.224.465q.074.015.149.016l16.034.19c.392.004.532-.494.187-.678-1.17-.625-2.59-1.24-5.396-2.442-.163-.07-.268-.27-.116-.36 1.12-.665 7.442 2.65 9.29 3.739q.104.06.22.087c2.403.549 4.232.813 7.748 2.232a.6.6 0 0 1 .248.177c.338.431 1.252 1.9.231 3.77a.71.71 0 0 1-.485.348l-3.63.76m-23.93 0h19.287M15.15 6.794l-.587-.976a.65.65 0 0 0-.498-.328 6 6 0 0 0-.41-.016c-.407-.002-.722.337-.722.744v.276m7.807.375a5 5 0 0 1-.088-.658.69.69 0 0 1 .67-.762c.122-.002.247 0 .365.007.2.012.372.133.482.3v0c.35.533-.058 1.279-.696 1.286l-.458.005c-.13.002-.246-.05-.275-.178Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.518,
    cy: 13.969,
    r: 2.331,
    stroke: "#1E242F",
    strokeWidth: 0.774
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M38.789 13.969a2.33 2.33 0 1 1-4.662 0 2.33 2.33 0 0 1 4.662 0Z"
  })));
};
export default SvgConvertibleDefault;